// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  margin: 50px auto;
  padding: 20px;
  border: 2px solid #f0ad4e; /* Yellow border */
  border-radius: 5px;
  background-color: #fcf8e3; /* Light yellow background */
  text-align: center;
}

.error-message {
  font-size: 20px;
  font-weight: bold;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/error/graph-error/graphError.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB,EAAE,kBAAkB;EAC7C,kBAAkB;EAClB,yBAAyB,EAAE,4BAA4B;EACvD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".error-container {\n  margin: 50px auto;\n  padding: 20px;\n  border: 2px solid #f0ad4e; /* Yellow border */\n  border-radius: 5px;\n  background-color: #fcf8e3; /* Light yellow background */\n  text-align: center;\n}\n\n.error-message {\n  font-size: 20px;\n  font-weight: bold;\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
